import { CKAvatar } from '@clearkit/react';
import gravatarUrl from 'gravatar-url';

import SalesforceOpportunityListItem from './salesforceOpportunity';
import TwoLineMenuItem from './TwoLineMenuItem';

const SalesforceContactMenuItem = ({
  salesforceContact,
  salesforceAccountConnector,
}) => (
  <div>
    <TwoLineMenuItem
      externalLinkClass="text-blue-500"
      href={`${salesforceAccountConnector.externalInstanceUrl}/${salesforceContact.externalId}`}
      icon={
        <CKAvatar
          src={gravatarUrl(salesforceContact.email)}
          size={32}
          className="shadow-sm"
        />
      }
      title={`${salesforceContact.name} (${salesforceContact.salesforceAccount?.name})`}
      subtitle={
        <>Owned by {salesforceContact?.owner?.name || 'Unknown User'}</>
      }
    />

    {salesforceContact?.opportunities?.length > 0 && (
      <span className="px-3 text-sm font-medium text-gray">
        {salesforceContact.opportunities?.length}{' '}
        {salesforceContact.opportunities?.length == 1
          ? 'opportunity'
          : 'opportunities'}
      </span>
    )}

    {salesforceContact?.opportunities?.map((opportunity) => {
      <SalesforceOpportunityListItem
        key={opportunity.externalId}
        salesforceOpportunity={opportunity}
        salesforceAccountConnector={salesforceAccountConnector}
      />;
    })}
  </div>
);

export default SalesforceContactMenuItem;
